import React from 'react';
import {Route, Redirect} from 'react-router-dom';

/**
 * Componente para renderizar rutas protegidas
 * @author Jhoan López <jhoanlt19@gmail.com>
 * @param {*} param0 
 */
const PrivateRoute = ({ component: Component, menu: Menu, ...rest }) => {
    return(
        <Route
            {...rest}
            render={props => {
                if(localStorage.getItem("token")){
                    if(!Menu){
                        return(
                            <Component {...props} {...rest}/>
                        )
                    } else {
                        return(
                            <React.Fragment>
                                <Menu/>
                                <Component {...props} {...rest}/>
                            </React.Fragment>
                        )
                    }
                } else {
                    return(
                        <Redirect
                            to={{
                            pathname: "/login",
                            //state: { from: location }
                            }}
                        />
                    )
                }
            }

            }
        />
    )
};

export default PrivateRoute;


// WEBPACK FOOTER //
// ./src/components/routes/privateRoute.js